import { render, staticRenderFns } from "./PauseDialog.vue?vue&type=template&id=2ecf61de&"
import script from "./PauseDialog.vue?vue&type=script&lang=js&"
export * from "./PauseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports